import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { personalDataTranslationKeys } from '../../../translations';

type PassportValidToFieldProps = FieldControllerProps<'passportValidTo', LocalDate | null>;

export const PassportValidToField = (props: PassportValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={'passportValidTo'}
         controller={props.register('passportValidTo', { required: true })}
         defaultValue={null}
         dayValidators={'dayBeforeToday'}
         label={personalDataTranslationKeys.passportValidTo.label}
         placeholder={personalDataTranslationKeys.passportValidTo.placeholder}
         withNavigationArrows
      />
   );
};
